import React, {Fragment} from 'react'
import * as Components from '../components/imagetool';
import {Route} from '../components/Router'

export const ImagetoolContainer = (props) => {
    return (
        <Fragment>
            <Route path="/ip/" exact={true} component={Components.Browser} />
            <Route path="/ip/Browser" component={Components.Browser} />
        </Fragment>
    )
}